import React from 'react';
import { Section } from '../ui/Section';
import { Calculator } from 'lucide-react';
export function Problem() {
  return <Section theme="onyx" className="border-b border-gold-hairline" data-id="element-120">
      <div className="mb-6 flex flex-col items-start" data-id="element-121">
        <div className="flex items-center gap-4 mb-4" data-id="element-122">
          <div className="h-[1px] w-8 bg-gold/30" data-id="element-123"></div>
          <span className="text-gold text-xs font-semibold tracking-[0.2em] uppercase" data-id="element-124">
            The Problem
          </span>
        </div>
      </div>

      <h2 className="text-3xl md:text-4xl font-serif font-medium mb-14 text-bone" data-id="element-125">
        The math doesn't work anymore.
      </h2>

      <div className="grid md:grid-cols-2 gap-12 mb-16" data-id="element-126">
        <div className="bg-graphite p-10 border border-gold-hairline shadow-editorial-dark relative overflow-hidden group hover:border-gold/40 transition-colors duration-500" data-id="element-127">
          <div className="absolute top-0 right-0 p-6 opacity-5 group-hover:opacity-10 transition-opacity duration-500" data-id="element-128">
            <Calculator className="w-32 h-32 text-gold" data-id="element-129" />
          </div>
          <p className="text-lg text-bone-muted leading-relaxed relative z-10" data-id="element-130">
            If you try to save for a traditional 20% downpayment on a $400,000
            home while paying record-high rent, you are chasing a moving target.
          </p>
          <div className="mt-8 pt-8 border-t border-gold-hairline relative z-10" data-id="element-131">
            <p className="text-3xl font-serif font-medium italic text-gold leading-tight" data-id="element-132">
              By the time you save $80k, the house will cost $500k.
            </p>
          </div>
        </div>

        <div className="space-y-8 text-lg text-bone-muted leading-relaxed" data-id="element-133">
          <p data-id="element-134">
            You are trapped in the{' '}
            <strong className="text-bone font-medium" data-id="element-135">
              "Retail Real Estate Loop."
            </strong>{' '}
            You're looking at polished, staged homes on the MLS that have
            already been picked clean of any profit.
          </p>
          <p data-id="element-136">
            You're competing with corporate buyers who have more cash than you.
            The gatekeepers don't want you to know how to find the "Warehouse"
            level of real estate—the auctions—because that's where the real
            equity is born.
          </p>
        </div>
      </div>
    </Section>;
}